import { render, staticRenderFns } from "./MainProductDetail.vue?vue&type=template&id=00698d9b&scoped=true"
import script from "./MainProductDetail.vue?vue&type=script&lang=js"
export * from "./MainProductDetail.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MainProductDetail.vue?vue&type=style&index=1&id=00698d9b&prod&scoped=true&lang=css"
import style2 from "../../../assets/styles/imgProduct.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00698d9b",
  null
  
)

export default component.exports